import { useDimensions } from "@repo/core/hooks/useDimensions";
import { ROUTES } from "@repo/core/routes";
import { useProposalFlowNavigation } from "../utils/proposalFlowNavigation";
import { useState } from "react";
import { useProposal } from "@repo/core/hooks/useProposal";
import { mockProducts } from "@repo/core/stores/proposalForm/mocks";

export const SelectProductController = () => {
  const { completeStep, goToPreviousStep } = useProposalFlowNavigation();
  const { isMobile } = useDimensions();
  const { selectedProduct, setSelectedProduct, isFidelityProposal } =
    useProposal();
  const [selectedProductId, setSelectedProductId] = useState<string | null>(
    selectedProduct?.id || null
  );

  const [products] = useState(mockProducts);

  const handleSelectProduct = (id: string) => {
    setSelectedProductId(id);
  };

  const handleOnSubmitForm = () => {
    const product = products.find((p) => p.id === selectedProductId);
    if (product) {
      setSelectedProduct(product);
    }

    if (isFidelityProposal) {
      completeStep(ROUTES.fidelityProposalReview);
      return;
    }
    completeStep(ROUTES.creditProposalReview);
  };

  const handleGoBack = () => {
    if (isFidelityProposal) {
      goToPreviousStep(ROUTES.fidelityProposalReview);
      return;
    }
    goToPreviousStep(ROUTES.creditProposalReview);
  };

  return {
    handleOnSubmitForm,
    handleGoBack,
    handleSelectProduct,
    isMobile,
    products,
    selectedProductId
  };
};
